module.exports = __webpack_public_path__ + "static/media/Bitmap.2e62ca2e.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/Bitmap.png
// module id = 1019
// module chunks = 0